import { hideStr, isMobile, showStr } from "./Config";
import { SearchInputRoute } from "./SearchInput";

export class Route {
    routeJSON = {};
    routeData;
    map;
    $element;
    $elFormGroup = [];
    nextWaypoint = 0;

    setMap(map) {
        this.map = map;
        return this;
    }

    build() {
        this.$element = $("#form-search-route");
        this.$element.on("submit", (e) => {
            e.preventDefault();
            this.writeRouteSummary();
            this.writeRouteSteps();
        });
        this.$elFormGroup = $('div.form-group[id^="mapbox-directions"]');

        this.$elFormGroup.each((index, item) => {
            new SearchInputRoute().setId($(item)).setMap(this.map).build();
        });
        let $elTopToggle = $("#mobileRouteTop .toggle");
        $elTopToggle.click((e) => {
            $elTopToggle.siblings(".content").toggle();
            $elTopToggle
                .children('[class^="icon"]')
                .toggleClass("icon-arrow_up icon-arrow_down");
            this.map.resize();
        });

        $("#form-search-route").on("click", ".switch", (e) => {
            e.preventDefault();
            let oItemOne = new RouteItem();
            oItemOne.root = $(e.currentTarget).parent().prev();
            let oItemTwo = new RouteItem();
            oItemTwo.root = $(e.currentTarget).parent();

            let tempVal = oItemOne.elInput.val();
            oItemOne.elInput.val(oItemTwo.elInput.val());
            oItemTwo.elInput.val(tempVal);

            let tempRouteItem = this.getRouteItem(oItemOne.dataItem);
            this.setRouteItem(
                oItemOne.dataItem,
                this.getRouteItem(oItemTwo.dataItem)
            );
            this.setRouteItem(oItemTwo.dataItem, tempRouteItem);

            this.map.clearMap({ route: false, pins: false, routepins: true });
            this.map.setPin("origin", this.map.route.origin);
            this.map.route.waypoints.forEach((value, index) => {
                this.map.setPin("waypoint" + index.toString(), value);
            });
            this.map.setPin("destination", this.map.route.destination);

            this.getRoute();
        });
        $("#means .col").click((e) => {
            if ($(e.currentTarget).hasClass("active") == false) {
                $("#means .col").removeClass("active");
                $(e.currentTarget).addClass("active");
                this.getRoute();
            }
        });
        $(".addStop").click((e) => {
            let $waypoint = $(
                '<div class="form-group" id="mapbox-directions-waypoint' +
                    this.nextWaypoint +
                    '" data-pin="routewaypoint' +
                    this.nextWaypoint +
                    '" data-item="waypoint' +
                    this.nextWaypoint +
                    '" />'
            );
            let $waypointSwitch = $(
                '<button class="btn switch"><i class="icon icon-switch"></i></button>'
            );
            let $waypointInputGroup = $('<div class="input-group ui-front">');
            let $waypointInput = $(
                '<div class="input-group-prepend"><label for="waypoint" class="input-group-text">&bull;</label></div><input id="waypoint' +
                    this.nextWaypoint +
                    '" class="form-control street" type="text" autocomplete="off" value="" required="required" name="waypoint" placeholder="Zwischenstop" data-routepoint="' +
                    this.nextWaypoint +
                    '" />'
            );
            let $waypointDelete = $(
                '<div class="btn delete"><i class="icon-minus"></i></div>'
            );
            $waypointDelete.on("click", (e) => {
                $waypoint.remove();
                this.map.route.waypoints.pop(this.nextWaypoint);
                this.map.clearMap({
                    route: false,
                    pins: false,
                    routepins: true,
                });
                this.map.setPin("origin", this.map.route.origin);
                this.map.route.waypoints.forEach((value, index) => {
                    this.map.setPin("waypoint" + index.toString(), value);
                });
                this.map.setPin("destination", this.map.route.destination);
                this.getRoute();
            });
            let $waypointClear = $(
                '<div class="btn clear"><i class="icon-close"></i></div>'
            );
            $waypointClear.on("click", (e) => {
                $waypointInput.val("");
                $waypointInput.focus();
            });
            let $waypointAutosuggest = $('<ul class="autosuggest" />');
            let $waypointButton = $(
                '<button id="waypoint' +
                    this.nextWaypoint +
                    'Button" class="hidden"/>'
            );
            $waypointInputGroup
                .append($waypointInput)
                .append($waypointDelete)
                .append($waypointClear)
                .append($waypointAutosuggest)
                .append($waypointButton);
            $waypoint.append($waypointSwitch).append($waypointInputGroup);

            $("#mapbox-directions-destination").before($waypoint);
            new SearchInputRoute()
                .setId($("#mapbox-directions-waypoint" + this.nextWaypoint))
                .setMap(this.map)
                .build();
            this.nextWaypoint++;
        });
    }

    getRouteItem(selector) {
        if (selector.indexOf("waypoint") >= 0) {
            let id = selector.replace("waypoint", "");
            return this.map.route.waypoints[id];
        } else {
            return this.map.route[selector];
        }
    }
    setRouteItem(selector, item) {
        if (selector.indexOf("waypoint") >= 0) {
            let id = selector.replace("waypoint", "");
            this.map.route.waypoints[id] = item;
        } else {
            this.map.route[selector] = item;
        }
    }

    getCurrentMean() {
        return $("#means .col.active").data("mean");
    }

    getRoute() {
        let start = this.map.route.origin;
        let end = this.map.route.destination;
        let stops = this.map.route.waypoints;
        let mean = this.getCurrentMean();
        let stopsString = "";

        stops.forEach((stop) => {
            stopsString += stop.geometry.coordinates.join() + ";";
        });

        $("input#origin").val(start.place_name);
        $("input#destination").val(end.place_name);

        $.ajax({
            type: "GET",
            url:
                "/servlet/getroute?type=" +
                mean +
                "&waypoints=" +
                start.geometry.coordinates.join() +
                ";" +
                stopsString +
                end.geometry.coordinates.join(),
            context: this,
            dataType: "JSON",
            success: (response) => {
                this.routeJSON = response.routes[0];

                let preferedRoute = polyline.toGeoJSON(
                    this.routeJSON.geometry,
                    5
                );
                let routeStart = {
                    type: "LineString",
                    coordinates: [
                        start.geometry.coordinates,
                        preferedRoute.coordinates[0],
                    ],
                };
                let routeEnd = {
                    type: "LineString",
                    coordinates: [
                        preferedRoute.coordinates[
                            preferedRoute.coordinates.length - 1
                        ],
                        end.geometry.coordinates,
                    ],
                };

                this.map.clearMap({
                    route: true,
                    pins: true,
                    routepins: false,
                });

                this.drawRoutePart("start", routeStart, -1);
                this.drawRoutePart(
                    "route",
                    polyline.toGeoJSON(this.routeJSON.geometry, 5),
                    0
                );
                this.drawRoutePart("end", routeEnd, -1);

                this.map.coordinates = [];
                this.map.coordinates = preferedRoute.coordinates;
                this.map.coordinates.unshift(start.geometry.coordinates);
                this.map.coordinates.push(end.geometry.coordinates);

                this.map.adjustZoom();
            },
            complete: () => {},
        });
    }

    drawRoutePart(name, data, index) {
        let paint = {
            "line-width": 6,
            "line-color": "#62719E",
            "line-opacity": 0.75,
        };
        let visible = "visible";

        if (index >= 0) {
            name = name + index;
        }
        if (index < 0) {
            paint["line-dasharray"] = [2, 1];
        }
        if (index > 0) {
            paint["line-color"] = "#000000";
            paint["line-opacity"] = 0.25;
        }

        let newLayer = {
            name: name,
            source: {
                type: "geojson",
                data: {
                    type: "Feature",
                    geometry: data,
                },
            },
            layer: {
                id: name,
                type: "line",
                source: name,
                paint: paint,
                layout: {
                    visibility: visible,
                },
            },
        };
        const waiting = () => {
            if (!this.map.map.isStyleLoaded()) {
                setTimeout(waiting, 200);
            } else {
                this.map.map.addSource(newLayer.name, newLayer.source);
                this.map.map.addLayer(newLayer.layer);
                this.map.additionalLayers.push(
                    newLayer
                ); /* HERO-1009: workaround for https://github.com/mapbox/mapbox-gl-js/issues/4000 */
            }
        };
        waiting();
    }

    writeRouteSummary() {
        let $element = $('<div id="routeSummary" class="col-19"/>');
        let $elDetails = $(
            "<h1>" +
                this.formatDuration(this.routeJSON.duration) +
                " (" +
                this.formatDistance(this.routeJSON.distance) +
                ")</h1>"
        );
        let $elSummary = $(
            "<p>über " + this.routeJSON.legs[0].summary + "</p>"
        );
        
        let $elShow = $('<div class="col-5"></div>');
        let $elToggle = $(
            '<div class="toggle"><i class="icon-arrow_up" aria-hidden="true"></i><p>Details</p></div>'
        );
        $elToggle.click((e) => {
            $elToggle
                .children('[class^="icon"]')
                .toggleClass("icon-arrow_up icon-arrow_down");
            let $buttonText = $elToggle.children("p");
            if ($buttonText.text() == "Details") {
                $buttonText.text("Karte");
                $("#mobileRouteBottom").css("top", "45px");
                $("#mobileRouteBottom .content").css("height", "100%");
                $("#routeSteps").attr("style", showStr);
            } else {
                $buttonText.text("Details");
                $("#mobileRouteBottom").css("top", "auto");
                $("#mobileRouteBottom .content").css("height", "inherit");
                $("#routeSteps").attr("style", hideStr);
            }
        });

        $($element).append($elDetails);
        $($element).append($elSummary);

        if (isMobile.matches) {
            $elShow.append($elToggle);
            $("#mobileRouteBottom").attr("style", showStr);
            $("#mobileRouteBottom .routeOverview").empty();
            $("#mobileRouteBottom .routeOverview").append($element);
            $("#mobileRouteBottom .routeOverview").append($elShow);
        } else {
            $("#form-search-route .routeOverview").empty();
            $("#form-search-route .routeOverview").append($element);
        }
    }

    writeRouteSteps() {
        let $element = $('<div id="routeSteps" class="col-24"/>');
        this.routeJSON.legs.forEach((leg) => {
            leg.steps.forEach((step) => {
                let $elStep = $('<div class="row step"/>')
                    .on("click", () => {
                        this.map.flyMeTo(
                            step.intersections[0].location,
                            null,
                            null,
                            14
                        );
                    })
                    .on("mouseover", () => {
                        let stepMarker = document.createElement("div");
                        stepMarker.className = "hbdpin routeStepPin";

                        let image = document.createElement("img");
                        image.src = "/images/mapPins/routeStep.svg";
                        stepMarker.appendChild(image);

                        let markerObject = new mapboxgl.Marker(
                            stepMarker
                        ).setLngLat(step.intersections[0].location);

                        markerObject.addTo(this.map.map);
                    })
                    .on("mouseleave", () => {
                        $(".hbdpin.routeStepPin").remove();
                    });

                let iconClass = step["maneuver"]["type"];
                if (step["maneuver"].hasOwnProperty("modifier")) {
                    iconClass += "_" + step["maneuver"]["modifier"];
                }
                iconClass = "direction_" + iconClass.replace(/ /g, "_");

                let $elIcon = $('<div class="col-3 step-icon"/>').addClass(
                    iconClass
                );

                let $elDesc = $('<div class="col-21 step-desc"/>').text(
                    step.maneuver.instruction
                );

                let $elHint = $('<p class="step-hint"/>');
                if (step.duration > 0) {
                    $elHint.text(
                        this.formatDuration(step.duration) +
                            " (" +
                            this.formatDistance(step.distance) +
                            ")"
                    );
                }

                $elDesc.append($elHint);
                $elStep.append($elIcon);
                $elStep.append($elDesc);
                $element.append($elStep);
            });
        });
        if (isMobile.matches) {
            $element.attr("style", hideStr);
            $("#mobileRouteBottom .content .routeDesc").append($element);
            this.map.resize();
        } else {
            $(".routeDesc").empty();
            $(".routeDesc").append($element);
        }
    }

    formatDuration(s) {
        var m = Math.floor(s / 60),
            h = Math.floor(m / 60);

        s %= 60;
        m %= 60;

        if (h === 0 && m === 0) return parseInt(s) + " Sek.";
        if (h === 0) return m + " Min.";

        return h + " Std. " + m + " Min.";
    }

    formatDistance(m) {
        var txt = m.toFixed(0) + " m";

        if (m >= 100000) {
            txt = (m / 1000).toFixed(0) + " km";
        } else if (m >= 10000) {
            txt = (m / 1000).toFixed(1) + " km";
        } else if (m >= 1000) {
            txt = (m / 1000).toFixed(2) + " km";
        }

        return txt.replace(".", ",");
    }

    getRouteData() {
        let routeData = {};

        routeData.origin = this.map.route.origin;
        routeData.destination = this.map.route.destination;
        routeData.printaction = "direction";
        routeData.profile = this.getCurrentMean();
        routeData.routes = [];
        routeData.routes[0] = this.routeJSON;

        return routeData;
    }
}

export class RouteItem {
    root;
    get elInput() {
        return this.root.children(".input-group").children("input");
    }
    get elPin() {
        return $("#" + this.root.data("pin"));
    }
    get dataItem() {
        return this.root.data("item");
    }
}